import React from 'react';
import { ArrowRightIcon, PhoneIcon } from 'lucide-react';
export const PHONE_DISPLAY = '(702) 213-3769';
export const PHONE_HREF = 'tel:+17022133769';
export const CTA_LABEL = 'Start My 72-Hour Launch';
export const CTA_HREF = '#start';
interface StartCtaProps {
  size?: 'md' | 'lg';
  className?: string;
}
export function StartCta({
  size = 'md',
  className = ''
}: StartCtaProps) {
  return <a href={CTA_HREF} className={`group inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-sm bg-brand-red font-display font-bold uppercase tracking-wide text-brand-white transition-[background-color,transform] duration-150 ease-out hover:bg-[#9d1a1f] active:translate-y-px focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-red ${size === 'lg' ? 'px-8 py-4 text-base sm:text-lg' : 'px-6 py-3.5 text-sm sm:text-base'} ${className}`} data-id="element-9" data-mp="qk21x8fpjog2">
      {CTA_LABEL}
      <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-10" data-mp="157de9cjprch8" />
    </a>;
}
interface CallCtaProps {
  variant?: 'onDark' | 'onLight';
  size?: 'md' | 'lg';
  className?: string;
}
export function CallCta({
  variant = 'onLight',
  size = 'md',
  className = ''
}: CallCtaProps) {
  const palette = variant === 'onDark' ? 'border-brand-white/40 text-brand-white hover:border-brand-white hover:bg-brand-white hover:text-brand-black' : 'border-brand-black/20 text-brand-black hover:border-brand-black hover:bg-brand-black hover:text-brand-white';
  return <a href={PHONE_HREF} className={`inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-sm border-2 font-display font-bold tracking-wide transition-[background-color,border-color,color] duration-150 ease-out focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-red ${palette} ${size === 'lg' ? 'px-8 py-4 text-base sm:text-lg' : 'px-6 py-3.5 text-sm sm:text-base'} ${className}`} data-id="element-11" data-mp="1jzbhax75hnd">
      <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-12" data-mp="3hz5jnynek6sj" />
      {PHONE_DISPLAY}
    </a>;
}